namespace appn.views.taskTemplates.connectors {

    class InitArgs {
        isFirstTimer: boolean = false;
    }

    let _initArgs: InitArgs;

    export function init(args: InitArgs): void {
        _initArgs = args;

        if (_initArgs.isFirstTimer)
            (appn as any).loadFirstTimeHelp();

        addEvents();
    }

    function addEvents() {
        // Hook save link
        $('#saveLink').on('click', function() {
            $('form#appnForm').submit();
        });

        $('.connectorOption:not(.connection-required)').on('click', function() {
            const form = $('form#appnForm');
            form.append(`<input type="hidden" name="submitType" value="${$(this).attr('id')}" />`);
            form.submit();
        });

        $('.httpVerb').on('change', function() {
            const connector = $(this).closest('.connector');
            const formatType = connector.find('.formatType');
            const verb = $(this).val();

            if (verb !== 'Post' && verb !== 'Put' && verb !== 'Patch') {
                formatType.find('option').not('[value="RawJson"]').not('[value="RawXml"]').addClass('d-none');
                if (formatType.val() !== 'RawJson' && formatType.val() !== 'RawXml') {
                    formatType.val('RawJson');
                    formatType.change();
                }
            } else
                formatType.find('option').removeClass('d-none');
        });

    }
}
